import Lineup from './lineup';
import {sortByProperty} from 'helpers/sorters';

export default class LineupTiers extends Lineup {
    setPlayersByColumns({incomingValues: {team}}) {
        team.sort(sortByProperty('rosterPositionName'));

        team.map((player) => {
            player.positionInLineup = 'T' + player.rosterPositionName;
        });
        return team;
    }
}
